import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
function changefingernail(imagePath, referencePath, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      10: {
        inputs: {
          seed: seed,
          steps: 20,
          cfg: 1,
          sampler_name: 'euler',
          scheduler: 'normal',
          denoise: 1,
          model: [
            '12',
            0
          ],
          positive: [
            '25',
            0
          ],
          negative: [
            '25',
            1
          ],
          latent_image: [
            '25',
            2
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      11: {
        inputs: {
          unet_name: 'flux1-fill-dev.safetensors',
          weight_dtype: 'fp8_e4m3fn'
        },
        class_type: 'UNETLoader',
        _meta: {
          title: 'Load Diffusion Model'
        }
      },
      12: {
        inputs: {
          model: [
            '11',
            0
          ]
        },
        class_type: 'DifferentialDiffusion',
        _meta: {
          title: 'Differential Diffusion'
        }
      },
      13: {
        inputs: {
          clip_name1: 'clip_l.safetensors',
          clip_name2: 't5xxl_fp8_e4m3fn.safetensors',
          type: 'flux',
          device: 'default'
        },
        class_type: 'DualCLIPLoader',
        _meta: {
          title: 'DualCLIPLoader'
        }
      },
      14: {
        inputs: {
          text: '',
          clip: [
            '13',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      15: {
        inputs: {
          text: '',
          clip: [
            '13',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      16: {
        inputs: {
          strength: 1.0000000000000002,
          strength_type: 'multiply',
          conditioning: [
            '14',
            0
          ],
          style_model: [
            '19',
            0
          ],
          clip_vision_output: [
            '20',
            0
          ]
        },
        class_type: 'StyleModelApply',
        _meta: {
          title: 'Apply Style Model'
        }
      },
      19: {
        inputs: {
          style_model_name: 'flux1-redux-dev.safetensors'
        },
        class_type: 'StyleModelLoader',
        _meta: {
          title: 'Load Style Model'
        }
      },
      20: {
        inputs: {
          crop: 'none',
          clip_vision: [
            '23',
            0
          ],
          image: [
            '97',
            0
          ]
        },
        class_type: 'CLIPVisionEncode',
        _meta: {
          title: 'CLIP Vision Encode'
        }
      },
      23: {
        inputs: {
          clip_name: 'sigclip_vision_patch14_384.safetensors'
        },
        class_type: 'CLIPVisionLoader',
        _meta: {
          title: 'Load CLIP Vision'
        }
      },
      24: {
        inputs: {
          guidance: 30,
          conditioning: [
            '16',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      25: {
        inputs: {
          noise_mask: false,
          positive: [
            '24',
            0
          ],
          negative: [
            '15',
            0
          ],
          vae: [
            '26',
            0
          ],
          pixels: [
            '30',
            0
          ],
          mask: [
            '46',
            0
          ]
        },
        class_type: 'InpaintModelConditioning',
        _meta: {
          title: 'InpaintModelConditioning'
        }
      },
      26: {
        inputs: {
          vae_name: 'FLUX.1-vae.sft'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      28: {
        inputs: {
          samples: [
            '10',
            0
          ],
          vae: [
            '26',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      30: {
        inputs: {
          direction: 'right',
          match_image_size: true,
          image1: [
            '31',
            0
          ],
          image2: [
            '33',
            0
          ]
        },
        class_type: 'ImageConcanate',
        _meta: {
          title: 'Image Concatenate'
        }
      },
      31: {
        inputs: {
          aspect_ratio: 'original',
          proportional_width: 1,
          proportional_height: 1,
          fit: 'letterbox',
          method: 'lanczos',
          round_to_multiple: '8',
          scale_to_side: 'height',
          scale_to_length: [
            '32',
            0
          ],
          background_color: '#000000',
          image: [
            '97',
            0
          ]
        },
        class_type: 'LayerUtility: ImageScaleByAspectRatio V2',
        _meta: {
          title: 'LayerUtility: ImageScaleByAspectRatio V2'
        }
      },
      32: {
        inputs: {
          value: 1024
        },
        class_type: 'ImpactInt',
        _meta: {
          title: 'ImpactInt'
        }
      },
      33: {
        inputs: {
          aspect_ratio: 'original',
          proportional_width: 1,
          proportional_height: 1,
          fit: 'letterbox',
          method: 'lanczos',
          round_to_multiple: '8',
          scale_to_side: 'height',
          scale_to_length: [
            '32',
            0
          ],
          background_color: '#000000',
          image: [
            '94',
            0
          ],
          mask: [
            '105',
            0
          ]
        },
        class_type: 'LayerUtility: ImageScaleByAspectRatio V2',
        _meta: {
          title: 'LayerUtility: ImageScaleByAspectRatio V2'
        }
      },
      35: {
        inputs: {
          images: [
            '30',
            0
          ]
        },
        class_type: 'PreviewImage',
        _meta: {
          title: 'Preview Image'
        }
      },
      40: {
        inputs: {
          width: [
            '31',
            3
          ],
          height: [
            '31',
            4
          ],
          red: 0,
          green: 0,
          blue: 0
        },
        class_type: 'Image Blank',
        _meta: {
          title: 'Image Blank'
        }
      },
      42: {
        inputs: {
          direction: 'right',
          match_image_size: true,
          image1: [
            '40',
            0
          ],
          image2: [
            '43',
            0
          ]
        },
        class_type: 'ImageConcanate',
        _meta: {
          title: 'Image Concatenate'
        }
      },
      43: {
        inputs: {
          mask: [
            '33',
            1
          ]
        },
        class_type: 'MaskToImage',
        _meta: {
          title: 'Convert Mask to Image'
        }
      },
      46: {
        inputs: {
          channel: 'red',
          image: [
            '42',
            0
          ]
        },
        class_type: 'ImageToMask',
        _meta: {
          title: 'Convert Image to Mask'
        }
      },
      52: {
        inputs: {
          width: [
            '55',
            0
          ],
          height: [
            '53',
            1
          ],
          position: 'top-left',
          x_offset: [
            '53',
            0
          ],
          y_offset: 0,
          image: [
            '28',
            0
          ]
        },
        class_type: 'ImageCrop+',
        _meta: {
          title: '🔧 Image Crop'
        }
      },
      53: {
        inputs: {
          image: [
            '31',
            0
          ]
        },
        class_type: 'easy imageSize',
        _meta: {
          title: 'ImageSize'
        }
      },
      55: {
        inputs: {
          image: [
            '33',
            0
          ]
        },
        class_type: 'easy imageSize',
        _meta: {
          title: 'ImageSize'
        }
      },
      94: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: '要修改的原图'
        }
      },
      97: {
        inputs: {
          image_url: referencePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: '替换的参考图'
        }
      },
      98: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '52',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      104: {
        inputs: {
          sam_model: 'sam_vit_l (1.25GB)',
          grounding_dino_model: 'GroundingDINO_SwinT_OGC (694MB)',
          prompt: 'fingernail',
          threshold: 0.3,
          fill_mode: 'On',
          image: [
            '94',
            0
          ]
        },
        class_type: '任意图像分割(Pro)',
        _meta: {
          title: '任意图像分割(Pro)'
        }
      },
      105: {
        inputs: {
          expand: 8,
          tapered_corners: true,
          mask: [
            '104',
            1
          ]
        },
        class_type: 'GrowMask',
        _meta: {
          title: 'GrowMask'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 98 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  changefingernail
}
